import React from 'react';

// Duotone Light n'existe pas dans les packages npm FA Pro installés (v6,
// duotone = un seul poids "solid"). Rendu via le kit FontAwesome déjà chargé
// (public/index.html, kit 7e58886003) qui détecte et remplace au runtime les
// balises <i class="fa-..."> — si le plan du kit inclut Duotone Light, ça
// marche sans toucher aux packages npm.
// `color` (extrait de `style`, comme le `color` retourné par iconButtonStyle)
// pilote les deux couches du duotone via --fa-primary-color/--fa-secondary-color,
// la 2e couche étant atténuée (secondaryOpacity) pour un rendu plus fin.
// `weight` : certaines icônes n'existent pas en Duotone Light dans le plan du
// kit (align-*, list-*, highlighter, at — rendu plat confirmé visuellement) →
// fallback vers 'solid' (Duotone classique, épais mais un vrai double-ton) au
// lieu de laisser le kit retomber silencieusement sur un rendu plat.
// `primaryColor`/`secondaryColor` : couleur propre de la 1re/2e couche (sinon
// `color`), pour montrer
// une valeur choisie dans l'icône elle-même (cf. NavbarListButton, colorInIcon).
const DuotoneLightIcon = ({ name, style = {}, secondaryOpacity = 0.4, primaryColor, secondaryColor, weight = 'light', className = '' }) => {
  const { color = 'currentColor', ...rest } = style;

  return (
    <i
      className={`fa-duotone fa-${weight} fa-${name}${className ? ` ${className}` : ''}`}
      style={{
        ...rest,
        '--fa-primary-color': primaryColor ?? color,
        '--fa-secondary-color': secondaryColor ?? color,
        '--fa-secondary-opacity': secondaryOpacity,
      }}
    />
  );
};

export default DuotoneLightIcon;
